import React from 'react'

import './styles.scss'

import backgroundImg from './img/background.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'já se casaram'
      : 'vão se casar'

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro210">
      <div className="bp1-intro210desktop anima-word-break ">
        <div className="bp1-mainbackground"></div>
        <div className="bp1-mask"></div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <div className="bp1-content1">
              <div className="bp1-photobg bp1-intro210-anima-animate-enter">
                <div className="bp1-divmask"></div>
                <img
                  alt="Image/"
                  src={background || backgroundImg}
                  className="bp1-bound"
                />
              </div>
              <div className="bp1-couplenames bp1-intro210-anima-animate-enter1">
                <span
                  data-id="Label-2b32c82f-fc8a-4f75-b58d-a69cad75103d bp1-span1"
                  className="bp1-span1 notranslate"
                >
                  {coupleSimplifiedName.groom
                    ? `${coupleSimplifiedName.bride} & ${coupleSimplifiedName.groom}`
                    : coupleSimplifiedName.bride}
                </span>
                <span
                  data-id="Label-2b32c82f-fc8a-4f75-b58d-a69cad75103d bp1-span2"
                  className="bp1-span2"
                >
                  <br />
                </span>
                <span
                  data-id="Label-2b32c82f-fc8a-4f75-b58d-a69cad75103d bp1-span3"
                  className="bp1-span3"
                >
                  {text}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp2-intro210mobile anima-word-break ">
        <div className="bp2-mainbackground"></div>
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <div className="bp2-content1">
              <div className="bp2-photobg bp2-intro210-anima-animate-enter">
                <div className="bp2-divmask"></div>
                <img
                  alt="Image/"
                  src={background || backgroundImg}
                  className="bp2-bound"
                />
              </div>
              <div className="bp2-couplenames bp2-intro210-anima-animate-enter1">
                <span
                  data-id="Label-da5df590-41f5-49a4-bbe9-c6e1c7c5a262 bp2-span1"
                  className="bp2-span1 notranslate"
                >
                  {coupleSimplifiedName.groom
                    ? `${coupleSimplifiedName.bride} & ${coupleSimplifiedName.groom}`
                    : coupleSimplifiedName.bride}
                </span>
                <span
                  data-id="Label-da5df590-41f5-49a4-bbe9-c6e1c7c5a262 bp2-span2"
                  className="bp2-span2"
                >
                  <br />
                </span>
                <span
                  data-id="Label-da5df590-41f5-49a4-bbe9-c6e1c7c5a262 bp2-span3"
                  className="bp2-span3"
                >
                  {text}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
